import { useEffect, useState } from "react";
import axios from "axios";

const base_url = process.env.REACT_APP_API_URL;

export default function Reports() {
  const token = localStorage.getItem("admin_token");

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [category, setCategory] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [summary, setSummary] = useState({
    credit: 0,
    debit: 0,
    profit: 0,
  });

  /* -------- Fetch Reports -------- */

  const fetchReports = async (
    p = page,
    s = search,
    t = type,
    c = category,
    st = status,
    f = fromDate,
    td = toDate,
  ) => {
    const res = await axios.get(
      `${base_url}/api/admin/reports?page=${p}&limit=10&search=${s}&type=${t}&category=${c}&status=${st}&fromDate=${f}&toDate=${td}`,
      {
        headers: { Authorization: token },
      },
    );

    if (res.data.success) {
      setData(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setPage(res.data.pagination.page);
      setSummary(res.data.summary);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  /* -------- Search -------- */

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    fetchReports(1, value, type, category, status);
  };

  /* -------- Filter handlers -------- */

  const handleType = (e) => {
    const value = e.target.value;
    setType(value);
    fetchReports(1, search, value, category, status);
  };

  const handleCategory = (e) => {
    const value = e.target.value;
    setCategory(value);
    fetchReports(1, search, type, value, status);
  };

  const handleStatus = (e) => {
    const value = e.target.value;
    setStatus(value);
    fetchReports(1, search, type, category, value);
  };

  /* -------- Pagination -------- */

  const nextPage = () => {
    if (page < totalPages) {
      fetchReports(page + 1, search, type, category, status);
    }
  };

  const prevPage = () => {
    if (page > 1) {
      fetchReports(page - 1, search, type, category, status);
    }
  };

  /* -------- Status badge -------- */

  const getStatusBadge = (status) => {
    if (status === 1) return <span className="badge bg-success">Success</span>;
    if (status === 2) return <span className="badge bg-danger">Failed</span>;
    return <span className="badge bg-warning text-dark">Pending</span>;
  };

  return (
    <div className="px-3 px-md-4">
      <h4 className="mb-3">Reports</h4>

      {/* Filters */}

      <div className="row g-2 mb-3">
        <div className="col-6 col-md-2">
          <input
            className="form-control"
            placeholder="Search phone"
            value={search}
            onChange={handleSearch}
          />
        </div>

        <div className="col-6 col-md-2">
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => {
              const value = e.target.value;
              setFromDate(value);
              fetchReports(1, search, type, category, status, value, toDate);
            }}
          />
        </div>

        <div className="col-6 col-md-2">
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => {
              const value = e.target.value;
              setToDate(value);
              fetchReports(1, search, type, category, status, fromDate, value);
            }}
          />
        </div>

        <div className="col-6 col-md-2">
          <select className="form-control" value={type} onChange={handleType}>
            <option value="">All Type</option>
            <option value="credit">Credit</option>
            <option value="debit">Debit</option>
          </select>
        </div>

        <div className="col-6 col-md-2">
          <select
            className="form-control"
            value={category}
            onChange={handleCategory}
          >
            <option value="">All Category</option>
            <option value="deposit">Deposit</option>
            <option value="withdraw">Withdraw</option>
            {/* <option value="aviator">Aviator</option> */}
            <option value="matka">Matka</option>
            <option value="lucky7">Lucky7</option>
            <option value="12 Tiles">12 Tiles</option>
            <option value="Mine game">Mine game</option>
            <option value="Win Go">Win Go</option>
            <option value="Spin Wheel">Spin Wheel</option>
          </select>
        </div>

        <div className="col-6 col-md-2">
          <select
            className="form-control"
            value={status}
            onChange={handleStatus}
          >
            <option value="">All Status</option>
            <option value="1">Success</option>
            <option value="0">Pending</option>
            <option value="2">Failed</option>
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-6 col-md-3 mb-lg-3">
          <div className="card bg-success text-white p-3">
            <h6>Total Deposit</h6>
            <h4>₹{summary.deposit}</h4>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-lg-3">
          <div className="card bg-danger text-white p-3">
            <h6>Total Withdraw</h6>
            <h4>₹{summary.withdraw}</h4>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-lg-3">
          <div className="card bg-primary text-white p-3">
            <h6>Deposit Profit</h6>
            <h4>₹{summary.profit}</h4>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-lg-3">
          <div className="card bg-dark text-white p-3">
            <h6>Total Bet</h6>
            <h4>₹{summary.bet}</h4>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-lg-3">
          <div className="card bg-warning text-dark p-3">
            <h6>Total Win</h6>
            <h4>₹{summary.win}</h4>
          </div>
        </div>

        <div className="col-6 col-md-3 mb-lg-3">
          <div
            className={`card p-3 ${summary.betProfit >= 0 ? "bg-success" : "bg-danger"} text-white`}
          >
            <h6>Bet Profit / Loss</h6>
            <h4>₹{summary.betProfit}</h4>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card shadow-sm">
        <div className="table-responsive">
          <table className="table table-hover">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Phone</th>
                <th>Amount</th>
                <th>Balance</th>
                <th>Type</th>
                <th>Category</th>
                <th>Status</th>
                <th>Remark</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>

                    <td>{item.phone}</td>

                    <td
                      className={
                        item.type === "credit"
                          ? "text-success fw-bold"
                          : "text-danger fw-bold"
                      }
                    >
                      ₹{item.amount}
                    </td>

                    <td>₹{item.current_money}</td>

                    <td>
                      {item.type === "credit" || item.type === "refund" ? (
                        <span className="badge bg-success">
                          {item.type.charAt(0).toUpperCase() +
                            item.type.slice(1)}
                        </span>
                      ) : (
                        <span className="badge bg-danger">
                          {item.type.charAt(0).toUpperCase() +
                            item.type.slice(1)}
                        </span>
                      )}
                    </td>

                    <td>
                      <span className="badge bg-primary">
                        {item.category.charAt(0).toUpperCase() +
                          item.category.slice(1)}
                      </span>
                    </td>

                    <td>{getStatusBadge(item.status)}</td>

                    <td>{item.remark || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No reports found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination */}

      <div className="d-flex justify-content-center gap-3 mt-3">
        <button
          className="btn btn-secondary"
          disabled={page === 1}
          onClick={prevPage}
        >
          Previous
        </button>

        <span className="align-self-center">
          Page {page} / {totalPages}
        </span>

        <button
          className="btn btn-secondary"
          disabled={page === totalPages}
          onClick={nextPage}
        >
          Next
        </button>
      </div>
    </div>
  );
}
